export default {
	suggestedUsers: [],
	suggestedUsersLimit: 10,
	suggestedUsersOffset: 0,
	suggestedUsersFetchCompleted: false 
}